// Updated React Component
import React, { useEffect, useState, useRef } from "react"
import { Link } from "react-router-dom"
import { motion as m } from "framer-motion"
import { useDispatch, useSelector } from "react-redux"
import {
  db,
  requestNotificationPermission,
  rtdb,
  auth,
} from "../../Firebase/config"
import UsefetchcollectionTime from "../Componentslogic/Usefetchcollectiontime"
import Spinner from "react-bootstrap/Spinner"
import { signOut } from "firebase/auth"
import {
  FILTER_BY_ORDER_NUMBERS_DELIVERY,
  SelectFilterOrdernumbersDelivery,
} from "../../redux/actions/FilterProducts"
import Modal from "react-modal"
import {
  RESET_NEW_DELIVERY_COUNT,
  SET_NEW_DELIVERY_COUNT,
} from "../../redux/actions/OrdersStaffslice"
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
  Timestamp,
  setDoc,
} from "firebase/firestore"
import "../../Styles/StaffDelivery.css"
import axios from "axios"
import { ref, update, remove } from "firebase/database"
import { useNavigate } from "react-router-dom"
import { GetoneDeliveryorderHook } from "../Componentslogic/ReservationHook/Getonedeliveryorder"
import Notify from "../Componentslogic/Usenotifications"

export const AllDeliveryOrdersStaff2 = () => {
  const {
    data: DeliveryorderData,
    loadMore,
    loading,
    hasMore,
    resetPaidOrders,
    resetdeliveredOrders,
  } = UsefetchcollectionTime("DeliveryOrders")
  const [OrderSearch, setOrdersearch] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [showSearch, setShowSearch] = useState(false)
  const [showReset, setShowReset] = useState(false)
  const [drivers, setDrivers] = useState([])
  const [selectedDriver, setSelectedDriver] = useState({})
  const [isPermissionGranted, setIsPermissionGranted] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [showPasswordModal, setShowPasswordModal] = useState(false)
  const [passwordInput, setPasswordInput] = useState("")
  const [editOrderId, setEditOrderId] = useState(null)
  const [orderItems, setOrderItems] = useState([])
  const [canEdit, setCanEdit] = useState(false)
  const [selectedOrderType, setSelectedOrderType] = useState("delivery")
  const [filterType, setFilterType] = useState(() => {
    return localStorage.getItem("orderFilterType") || "pending" // Default to 'pending'
  })

  const dispatch = useDispatch()
  // 🔥 Create a reference for the search input
  const searchInputRef = useRef(null)

  const handleSearchClick = () => {
    if (showSearch) {
      setSearchTerm("")
    }
    setShowSearch((prev) => !prev)
    window.scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus()
      }
    }, 300)
  }

  useEffect(() => {
    // Reset the new orders badge when the user opens this page
    dispatch(RESET_NEW_DELIVERY_COUNT())
  }, [dispatch])

  const [
    handleDonepreparing,
    handleDelete,
    disable,
    paid,
    handleOntheway,
    handleCheckDelivery,
    handleDelivered,
  ] = GetoneDeliveryorderHook()

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const driverRef = collection(db, "Staff")
        const q = query(driverRef, where("role", "==", "Driver"))
        const querySnapshot = await getDocs(q)
        const driverList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        setDrivers(driverList)
      } catch (error) {}
    }
    fetchDrivers()
  }, [])

  const navigate = useNavigate()

  const handleConfirmOrder = async (order) => {
    try {
      if (!order) return

      // Reference to RTDB order ID
      const orderRef = ref(rtdb, `DeliveryOrders/${order.id}`)

      // Update order in Realtime Database
      await update(orderRef, { ConfirmedStaff: true })

      Notify("Order confirmed successfully!", "success")
    } catch (error) {
      console.error("Error confirming order:", error)
    }
  }

  const handleFilterChange = (type) => {
    setFilterType(type)
    localStorage.setItem("orderFilterType", type) // Save selection
  }

  const handleAssignDriver = async (orderId, orderDetails) => {
    if (!selectedDriver[orderId]) {
      alert("Please select a driver before assigning!")
      return
    }

    const { name, contactNumber } = selectedDriver[orderId]

    try {
      const updates = {
        assignedDriver: name,
        driverPhoneNumber: contactNumber,
      }

      const orderRef = doc(db, "DeliveryOrders", orderId)
      await updateDoc(orderRef, updates)

      const orderRTDBRef = ref(rtdb, `DeliveryOrders/${orderId}`)
      await update(orderRTDBRef, updates)

      Notify("Driver assigned successfully!", "success")
    } catch (error) {
      alert("Failed to assign driver. Try again.")
    }
  }

  const toggleResetButton = () => {
    setShowReset((prev) => !prev)
  }

  // 🔥 Function to Reset Orders & Logout User
  const handleResetAndLogout = async () => {
    try {
      await resetdeliveredOrders() // ✅ Reset Orders in Database
      await signOut(auth) // ✅ Sign out user from Firebase

      // ✅ Clear Session Cookie
      document.cookie =
        "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"

      // ✅ Redirect to Login Page

      navigate("/Login")
    } catch (error) {
      console.error("Error resetting orders and logging out:", error)
    }
  }

  // ✅ Handle Password Submission
  const handlePasswordSubmit = () => {
    if (passwordInput === process.env.REACT_APP_ADMIN_PASSWORD) {
      setCanEdit(true)
      Notify("Access Granted! You can now edit the order.", "success")
    } else {
      Notify("Incorrect password!", "error")
    }
  }

  // ✅ Open Edit Modal
  const handleEditOrder = (order) => {
    setEditOrderId(order.id)
    setOrderItems([...order.cart]) // Load order items
    setShowPasswordModal(true)
    setCanEdit(false) // Reset editing access
  }

  // ✅ Handle Item Removal
  const handleRemoveItem = async (index) => {
    if (!canEdit) return // Prevent removal if password is incorrect

    const updatedItems = [...orderItems]
    updatedItems.splice(index, 1) // Remove item
    const newTotal = updatedItems.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    )

    setOrderItems(updatedItems)

    try {
      const orderRef = doc(db, "DeliveryOrders", editOrderId)
      await updateDoc(orderRef, { cart: updatedItems, orderAmount: newTotal }) // Firestore update

      const orderRTDBRef = ref(rtdb, `DeliveryOrders/${editOrderId}`)
      await update(orderRTDBRef, { cart: updatedItems, orderAmount: newTotal }) // RTDB update

      Notify("Item removed successfully!", "success")
    } catch (error) {
      console.error("Error updating order:", error)
      Notify("Failed to remove item.", "error")
    }
  }
  // Filter orders
  // Filter orders
  const filteredOrders = DeliveryorderData.filter((order) => {
    if (filterType === "pending") {
      return !order.ConfirmedStaff
    } else {
      return order.ConfirmedStaff
    }
  })

  // Search all orders
  const searchedOrders = DeliveryorderData.filter((order) =>
    order.orderNumber
      .toString()
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  )

  return (
    <div className="orders-container mt-5">
      <div className="order-type-buttons mt-5">
        <button
          className={`order-type-btn ${
            selectedOrderType === "dine-in" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/staffpage/status")
          }}
        >
          Dine-In Orders
        </button>

        <button
          className={`order-type-btn ${
            selectedOrderType === "delivery" ? "active" : ""
          }`}
          style={{ position: "relative" }}
        >
          Delivery Orders
        </button>
      </div>
      <div className="filter-buttons">
        <button
          className={`filter-btn ${filterType === "pending" ? "active" : ""}`}
          onClick={() => handleFilterChange("pending")}
        >
          Pending Orders
        </button>
        <button
          className={`filter-btn ${filterType === "confirmed" ? "active" : ""}`}
          onClick={() => handleFilterChange("confirmed")}
        >
          Confirmed Orders
        </button>
      </div>
      {showSearch && (
        <div className="search-bar-container">
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search by Order ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar-orders"
          />
        </div>
      )}
      {showReset && (
        <div className="search-bar-container">
          <button className="reset-orders-btn" onClick={handleResetAndLogout}>
            Reset Orders
          </button>
        </div>
      )}

      <div className="orders-wrapper">
        <div className="orders-list">
          {(searchTerm ? searchedOrders : filteredOrders).length > 0 ? (
            (searchTerm ? searchedOrders : filteredOrders)
              .filter(
                (item) =>
                  item.orderNumber
                    .toLowerCase()
                    .includes(OrderSearch.toLowerCase()) ||
                  item.address.area
                    .toLowerCase()
                    .includes(OrderSearch.toLowerCase())
              )
              .map((item, index) => {
                return (
                  <m.div
                    className="order-card mb-5"
                    key={index}
                    initial={{ opacity: 0, x: 15 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    <div className="order-header">
                      <h3>Order-Number: {item.orderNumber}</h3>
                      <p>
                        Status:{" "}
                        {item.ConfirmedStaff && !item.Donepreparing && (
                          <span
                            className="badge-Not bg-danger"
                            onClick={() => handleDonepreparing(item.id)}
                          >
                            Preparing
                          </span>
                        )}
                        {item.Donepreparing &&
                          !item.ontheWay &&
                          !item.delivered && (
                            <span className="badge-Not  bg-success">
                              Done Preparing
                            </span>
                          )}
                        {item.ontheWay && !item.delivered && (
                          <span className="badge-Deliver  bg-success">
                            On the way
                          </span>
                        )}
                        {item.delivered && (
                          <span className="badge-Deliver  bg-success">
                            Delivered
                          </span>
                        )}
                      </p>
                    </div>

                    <div className="order-items">
                      <h4>Order Items:</h4>
                      <div className="order-items">
                        <ul>
                          {item.cart.map((orderItem, idx) => (
                            <li key={idx}>
                              {orderItem.CartTotalQuantity} x {orderItem.name}{" "}
                              {orderItem.selectedSize ? (
                                <span className="fw-bold">
                                  {" "}
                                  - {orderItem.selectedSize}{" "}
                                </span>
                              ) : null}
                              <div
                                className="d-flex justify-content-center"
                                style={{ gap: "8px" }}
                              >
                                {orderItem.spiceLevel && (
                                  <div className="d-flex justify-content-center mt-2 mb-2">
                                    <div>
                                      <span className="option-square selected p-2">
                                        <b> Spice: </b> {orderItem.spiceLevel}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {orderItem.combo && orderItem.combo.name && (
                                  <div className="d-flex justify-content-center mt-2 mb-2">
                                    <span className="option-square selected p-2">
                                      <b>Combo:</b> {orderItem.combo.name}
                                    </span>
                                  </div>
                                )}

                                {orderItem.freeSauce && (
                                  <div className="d-flex justify-content-center mt-2 mb-2">
                                    <span className="option-square selected p-2">
                                      <b> Sauce:</b> {orderItem.freeSauce}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="Horizontal-divider"></div>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="d-flex justify-content-center align-items-center">
                        <p
                          className="clickable-text p-0 m-0"
                          onClick={() => {
                            setSelectedAddress(item.address)
                            setShowAddressModal(true)
                          }}
                        >
                          📍 {item.address.area}
                        </p>
                      </div>
                    </div>

                    {item.Donepreparing && (
                      <div className="driver-assignment">
                        <div className="Horizontal-divider"></div>
                        <h4>
                          Assigned Driver:{" "}
                          {item.assignedDriver
                            ? item.assignedDriver
                            : "Not Assigned"}
                        </h4>
                        {!item.delivered && (
                          <>
                            <select
                              onChange={(e) => {
                                const selectedDriverName = e.target.value
                                const driverData = drivers.find(
                                  (driver) => driver.name === selectedDriverName
                                )

                                setSelectedDriver({
                                  ...selectedDriver,
                                  [item.id]: {
                                    name: driverData.name,
                                    contactNumber: driverData.contactNumber,
                                  },
                                })
                              }}
                              value={selectedDriver[item.id]?.name || ""}
                            >
                              <option value="">Select a driver</option>
                              {drivers.map((driver) => (
                                <option key={driver.id} value={driver.name}>
                                  {driver.name}
                                </option>
                              ))}
                            </select>
                            <button
                              className="assign-button"
                              onClick={() =>
                                handleAssignDriver(item.id, {
                                  Area: item.address.area,
                                  street: item.address.street,
                                })
                              }
                            >
                              {item.assignedDriver
                                ? "Reassign Driver"
                                : "Assign Driver"}
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    <div className="d-flex justify-content-center ">
                      <p className="mt-3 p-0 m-0 ">
                        <b>Total: {item.totalAmount.toFixed(2)}</b>
                      </p>
                    </div>
                    <div className="Horizontal-divider"></div>
                    <div
                      className="d-flex justify-content-center "
                      style={{ gap: "10px" }}
                    >
                      {!item.delivered && (
                        <div className="d-flex justify-content-center">
                          <button
                            className="btns-Admin"
                            onClick={() => handleEditOrder(item)}
                          >
                            Edit Order
                          </button>
                        </div>
                      )}

                      {!item.ConfirmedStaff ? (
                        <div className="d-flex justify-content-center">
                          <button
                            className="btns-Admin"
                            style={{ backgroundColor: "Green" }}
                            onClick={() => handleConfirmOrder(item)}
                          >
                            Confirm Order
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center">
                          <span className="badge-Deliver  bg-success mb-3 ">
                            Confirmed
                          </span>
                        </div>
                      )}
                    </div>
                  </m.div>
                )
              })
          ) : (
            <h3>No orders available</h3>
          )}
        </div>
      </div>
      {/* Address Modal */}
      <Modal
        isOpen={showAddressModal}
        onRequestClose={() => setShowAddressModal(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          },
          content: {
            position: "static",
            inset: "unset",
            width: "400px",
            height: "fit-content",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
      >
        {selectedAddress && (
          <div>
            <h3 style={{ textAlign: "center" }}>Full Address</h3>
            <p>
              <strong>Area:</strong> {selectedAddress.area}
            </p>
            <p>
              <strong>Street:</strong> {selectedAddress.street}
            </p>
            <p>
              <strong>Building:</strong> {selectedAddress.buildingName}, Floor:{" "}
              {selectedAddress.floor}, Apt:
              {selectedAddress.aptNo}
            </p>
            {selectedAddress.directions && (
              <p>
                <strong>Directions:</strong> {selectedAddress.directions}
              </p>
            )}
            <p>
              <strong>Phone:</strong> {selectedAddress.contactNumber}
            </p>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={showPasswordModal}
        onRequestClose={() => setShowPasswordModal(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          },
          content: {
            position: "static",
            inset: "unset",
            width: "400px",
            height: "fit-content",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
      >
        <h3 style={{ textAlign: "center" }}>Enter Password to Edit Order</h3>
        {!canEdit ? (
          <>
            <input
              type="password"
              className="input"
              placeholder="Enter password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
            />
            <button className="btns-Admin mt-2" onClick={handlePasswordSubmit}>
              Submit
            </button>
          </>
        ) : (
          <>
            <h4>Order Items:</h4>
            {orderItems.map((item, idx) => (
              <div
                key={idx}
                className="order-item d-flex justify-content-between"
              >
                <p className="mb-3">
                  {item.name} x {item.selectedSize} - Qty: {item.quantity}
                </p>
                <button
                  className="btns-Admin mb-3"
                  onClick={() => handleRemoveItem(idx)}
                  style={{ backgroundColor: "red" }}
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              className="btns-Admin mt-2"
              onClick={() => setShowPasswordModal(false)}
            >
              Close
            </button>
          </>
        )}
      </Modal>

      <div className="floating-search-btn">
        <p className="reset-orders-btn" onClick={handleSearchClick}>
          {showSearch ? "Hide " : "Search"}
        </p>
        <p
          className="reset-orders-btn"
          onClick={() => {
            toggleResetButton()
            window.scrollTo({ top: 0, behavior: "smooth" }) // 🔥 Scrolls to top smoothly
          }}
        >
          {showReset ? "Hide" : "Reset"}
        </p>
      </div>
    </div>
  )
}

export default AllDeliveryOrdersStaff2
